<template>
  <div v-if="balance">
    <h4>Saldo actual: {{ balance.saldo }} €</h4>

    <template v-if="admin">
    <router-link :to="`/admin/familia/${this.id_familia}/apunte/nuevo`">
    <button type="button" class="btn btn-primary mt-1 mb-3">Añadir apunte</button>
    </router-link>
    </template>

    <table class="table">
      <tr class="table-success"><th>Fecha</th><th>Concepto</th><th class="text-right">Importe</th><th class="text-right">Saldo</th><template v-if="admin"><th></th></template></tr>
      <tbody v-for="mes in balance.meses" :key="mes.mes">
      <tr class="table-primary">
        <td :colspan="admin ? 5 : 4" class="text-center"><b>{{ mes.mes | mostrarMes }}</b></td>
      </tr>
      <tr v-for="mov in mes.movimientos" :key="mov.id">
        <td class="align-middle">{{ mov.fecha | fechaTimestamp }}</td>
        <td class="align-middle">{{ mov.concepto }}</td>
        <td class="align-middle text-right"><span style="white-space: nowrap;">{{ mov.importe }}&nbsp;€</span></td>
        <td class="align-middle text-right"><span style="white-space: nowrap;">{{ mov.saldo }}&nbsp;€</span></td>
        <template v-if="admin">
        <td class="align-middle text-right"><router-link :to="`/admin/familia/${id_familia}/apunte/${mov.id}`"><button type="button" class="btn btn-sm btn-outline-secondary boton-detalles">Detalles</button></router-link></td>
        </template>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import { api } from '../api/api.js';

export default {
	name: 'SociosBalance',
	props: ['admin', 'id_familia'],
	data () {
		return {
			balance: null,
		}
	},
	created () {
		this.obtenerBalance();
	},
	methods: {
		obtenerBalance () {
			const id_familia = this.id_familia ? this.id_familia : this.$parent.sesion.id_familia;
			api(`/familias/${id_familia}/balance`)
                .then((data) => {
					this.balance = data.resultado;
                })
                .catch((error) => {
                    this.mensaje_error = error;
                });
		}
	},
	filters: {
		mostrarMes(mes) {
			return mes.substring(4, 6) + '/' + mes.substring(0, 4)
		},
		fechaTimestamp(timestamp) {
			const d = new Date(timestamp * 1000);
			return `${d.getDate()}/${d.getMonth()+1}/${d.getFullYear()}`;
		}
	}
}
</script>
